// extracted by mini-css-extract-plugin
module.exports = {"title":"_3JvE9ha4wtumJZJxCQVSCK","border":"_32dEK7uQ7r55BwiILXUDLO"};